require('./plan-box-template.html');

angular.module('bbl.module.plans-billings')
.directive('planBox', function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'plan-box-template.html',
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/plans-billings/plan-box/index.js
 ** module id = 373
 ** module chunks = 0
 **/